import { LucidePackageOpen, Plus } from 'lucide-react';
import { Button } from '@/components/Button';
import { EmptyState } from '@/components/EmptyState';

export function FilamentSystemsPage() {
  return (
    <div className="p-4">
      {/* Page header */}
      <div className="mb-4 flex items-center justify-between">
        <div>
          <h1 className="text-lg font-semibold text-foreground">Filament Systems</h1>
          <p className="text-sm text-foreground-muted">Manage multi-material units and filament changers</p>
        </div>
        <Button size="sm" leftIcon={<Plus className="h-4 w-4" />}>
          Add System
        </Button>
      </div>

      {/* Empty state */}
      <div className="rounded border border-border bg-background-subtle p-4">
        <EmptyState
          icon={<LucidePackageOpen className="h-10 w-10" />}
          title="No filament systems yet"
          description="Track your multi-material units like AMS, MMU, and other filament management systems."
          actionLabel="Add System"
          onAction={() => {
            // TODO: Open add filament system modal
          }}
        />
      </div>
    </div>
  );
}
